const showNotification = localStorage.getItem('showNotification');

// Shifted elements = Small header, hamburger button, small navigation, and small navigation overlay
let shiftedMobileElements = $('#header-small, .navigation-small-button-container, #navigation-small, .navigation-small-background-overlay');

// Mobile behaviour
$(document).ready(function () {
  if ($('.notification-bar').length) {

    $(shiftedMobileElements).css({
      'top': $('.notification-bar').outerHeight() + 'px'
    });
  }
});

// Set removed state of notification
if (showNotification === 'false') {
  $('.notification-bar').remove();
}

// Close notification and store in session
$('.close-notification').on('click', function () {
  $('.notification-bar').remove();

  // Restore mobile position of shifted elements
  $(shiftedMobileElements).css({
    'top': 0
  });
  localStorage.setItem('showNotification', 'false');
});
